import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { useEcommerceContext } from '@blaze-cms/ecommerce-context';
import { GET_PRODUCT_VARIANTS_QUERY } from '../../services';
import { CONTEXT_KEYS, EVENT_NAMES } from '../constants';
import { addPublishedEntityPrefix } from '../helpers';
import AddToCart from './AddToCart';
import { getSelectedVariant } from './helpers';

const AddToCartContainer = ({ parent, addToText, preorderText, modifier }) => {
  const { currencyKey, variantKey } = CONTEXT_KEYS;
  const { itemEntity: parentEntity, itemId: parentId } = parent;
  const { [currencyKey]: currency, [variantKey]: variant, emitCartEvent } = useEcommerceContext();
  const [selectedVariantData, setSelectedVariantData] = useState({});

  const {
    data: { productVariants } = {},
    error: variantsError,
    loading: variantsLoading
  } = useQuery(GET_PRODUCT_VARIANTS_QUERY, {
    variables: {
      id: parentId,
      entityIdentifier: addPublishedEntityPrefix(parentEntity),
      currency
    }
  });

  useEffect(
    () => {
      if (variant && variant === selectedVariantData.variantId) return;

      const selectedVariant = getSelectedVariant(variant, productVariants);
      if (selectedVariant && selectedVariant.variantId === selectedVariantData.variantId) return;

      if (emitCartEvent) {
        emitCartEvent({ eventName: EVENT_NAMES.view_item, input: { selectedVariant, parentId } });
      }
      setSelectedVariantData(selectedVariant);
    },
    [variant, productVariants, selectedVariantData.variantId, emitCartEvent, parentId]
  );

  if (variantsLoading) return null;
  if (variantsError) return variantsError.message;

  return (
    <AddToCart
      itemId={parentId}
      productVariants={productVariants}
      selectedVariantData={selectedVariantData}
      addToText={addToText}
      preorderText={preorderText}
      modifier={modifier}
    />
  );
};

AddToCartContainer.propTypes = {
  parent: PropTypes.object.isRequired,
  addToText: PropTypes.string,
  preorderText: PropTypes.string,
  modifier: PropTypes.string
};

AddToCartContainer.defaultProps = {
  addToText: null,
  preorderText: null,
  modifier: null
};

export default AddToCartContainer;
